import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import PainPointsSection from './components/PainPointsSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import ServiceAreasSection from './components/ServiceAreasSection';
import GoogleReviewsSection from './components/GoogleReviewsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import FinalCtaSection from './components/FinalCtaSection';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": `${siteUrl}/#organization`,
          "name": "Leak Detectives",
          "url": siteUrl,
          "telephone": "(725) 267-5482",
          "priceRange": "$$",
          "image": `${siteUrl}/logo.png`,
          "logo": `${siteUrl}/logo.png`,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "",
            "addressLocality": "Las Vegas",
            "addressRegion": "NV",
            "postalCode": "",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "36.1699",
            "longitude": "-115.1398"
          },
          "areaServed": [
            {
              "@type": "City",
              "name": "Las Vegas"
            },
            {
              "@type": "AdministrativeArea",
              "name": "Clark County"
            }
          ],
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday"
            ],
            "opens": "00:00",
            "closes": "23:59"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Plumbing Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Pool Leak Detection & Repair",
                  "description": "Professional pool leak detection and repair services using advanced technology"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Slab Leak Repair",
                  "description": "Expert slab leak detection and repair for residential and commercial properties"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Water Leak Detection",
                  "description": "Certified water leak detection services with flat-rate pricing"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Home Repiping",
                  "description": "Complete home repiping services for residential properties"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "24-Hour Emergency Plumbing",
                  "description": "24/7 emergency plumbing services available anytime"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Water Heater Installation",
                  "description": "Professional water heater installation and replacement services"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Drain Cleaning",
                  "description": "Professional drain cleaning and maintenance services"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Sewer Line Repair",
                  "description": "Expert sewer line repair and replacement services"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Mainline Replacement",
                  "description": "Complete mainline replacement services for residential and commercial properties"
                }
              }
            ]
          }
        },
        {
          "@type": "WebSite",
          "@id": `${siteUrl}/#website`,
          "url": siteUrl,
          "name": "Leak Detectives",
          "publisher": {
            "@id": `${siteUrl}/#organization`
          }
        },
        {
          "@type": "WebPage",
          "@id": `${siteUrl}/#webpage`,
          "url": siteUrl,
          "name": "Certified Leak Detection & Professional Plumbing Las Vegas",
          "isPartOf": {
            "@id": `${siteUrl}/#website`
          },
          "about": {
            "@id": `${siteUrl}/#organization`
          },
          "description": "Leak Detectives provides certified leak detection and professional plumbing services for homes and businesses across Las Vegas. 24/7 emergency service, flat-rate pricing, licensed & insured."
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Do you offer same-day leak detection?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes — we offer same-day service throughout Las Vegas and surrounding areas. When you call, we respond quickly and get to work locating the source of the leak."
              }
            },
            {
              "@type": "Question",
              "name": "Will you have to break walls or concrete?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "No — we specialize in non-invasive leak detection. Our goal is to locate the leak without unnecessary damage. If access is ever required, we'll explain everything before moving forward."
              }
            },
            {
              "@type": "Question",
              "name": "How long does leak detection take?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Every leak is different. Some are straightforward, while others require more detailed testing. We use flat-rate pricing, so your cost does not change based on time."
              }
            },
            {
              "@type": "Question",
              "name": "Do I need to know where the leak is before calling?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "No — that's exactly what we're here for. We use professional equipment to pinpoint the source of the leak accurately."
              }
            },
            {
              "@type": "Question",
              "name": "Do you work with insurance claims?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes — we can assist with documentation and help guide you through the process if your leak may be covered by insurance."
              }
            },
            {
              "@type": "Question",
              "name": "What areas do you serve?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We serve Las Vegas, Clark County, and surrounding areas including Henderson, North Las Vegas, Summerlin, and Paradise."
              }
            },
            {
              "@type": "Question",
              "name": "Do you offer 24/7 emergency plumbing services?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we provide 24-hour emergency plumbing services 365 days a year. Call us anytime at (725) 267-5482."
              }
            },
            {
              "@type": "Question",
              "name": "What is your pricing structure?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We offer flat-rate pricing with no hourly billing. You'll know the cost upfront before we start any work."
              }
            },
            {
              "@type": "Question",
              "name": "Are you licensed and insured?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, Leak Detectives is fully licensed and insured. Our technicians are certified leak detection specialists."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": siteUrl
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    script.id = 'schema-org-jsonld';
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('schema-org-jsonld');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen scroll-smooth">
      <Navbar />
      <HeroSection />
      <TrustSection />
      <PainPointsSection />
      <ServicesSection />
      <WhyChooseUsSection />
      <ServiceAreasSection />
      <GoogleReviewsSection />
      <ContactSection />
      <FAQSection />
      <FinalCtaSection />
      <Footer />
    </div>
  );
}